export default {
  highlightProductTitle: 'New products',
  projectTitle: 'Projects',
  bespokeTitle: 'Bespoke',
}
